import { Auth } from '../Auth'
import { AuthInvalidHash } from '../AuthInvalidHash'

import { useSharedRequestExchange } from './SharedRequest.hooks'

/**
 * Magic-link entry for external partners. Exchanges the email hash for a token
 * via the webapp auth endpoint, then re-bootstraps the app as that partner and
 * lands on the redesign request profile (loaded from this project's own API).
 * An invalid/expired hash shows the shared auth "invalid link" panel.
 */
function SharedRequest() {
  const { isValidHash, loading } = useSharedRequestExchange()

  return (
    <Auth loading={loading}>
      {isValidHash ? null : (
        <AuthInvalidHash
          text='Auth.InvalidSharedRequestHashTextKey'
          title='Auth.InvalidSharedRequestHashTitleKey'
        />
      )}
    </Auth>
  )
}

export default SharedRequest
